import User from '@core/models/user/User';
import store from '@store/index';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import {
    computed,
    onUnmounted,
} from '@vue/composition-api';

const fallbackTimeout = 3000;

export function useContextChange(onContextChange: () => void) {
    const user = computed(() => store.getters['data/authentication/user'] as User | null);
    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (
        (user.value !== null && featureFlagService.lastContext.user?.anonymous)
            || (user.value === null && !featureFlagService.lastContext.user?.anonymous)
    ) {
        timeout = setTimeout(() => handleTimeout(), fallbackTimeout);
    } else {
        onContextChange();
    }

    const unsubscribeContextChange = featureFlagService.subscribeToContextChange(() => handleContextChange());

    function handleTimeout() {
        // the context has not changed in 3 seconds, we will read the flag value anyway.
        // this should not happen, but it is fallback behavior in case something goes wrong.
        timeout = undefined;

        onContextChange();
    }

    function handleContextChange() {
        // the context has changed already, we don't need the timeout anymore.
        if (timeout !== undefined) {
            clearTimeout(timeout);
            timeout = undefined;
        }

        onContextChange();
    }

    onUnmounted(() => {
        unsubscribeContextChange();
    });
}
